import React from "react";
import { IonModal, IonButton, IonIcon } from "@ionic/react";
import { checkmarkCircle } from "ionicons/icons";
import dsCoinImage from "../../../assets/images/ds-coin.png";

const ActivitySuccessModal = ({ isOpen, onClose, result, challenge }) => {
  // Read the actual credited amount from the response — single source of truth.
  // Backend response shape (POST .../activities/...):
  //   {
  //     coin_transaction: { points, balance_after, ... } | null,
  //     bonus_coin_transaction: { points, ... } | null,
  //     activity: { attributes: { points_earned } },
  //     subscription: { attributes: { points_earned, bonus_earned, completed_at } },
  //   }
  // Prefer coin_transaction.points (authoritative for "what just got credited"),
  // then fall back to activity.attributes.points_earned, then to the challenge
  // reward as a last resort. Stops at 0 only when nothing else is available.
  const subAttrs =
    result?.subscription?.data?.attributes ?? result?.subscription?.attributes ?? {};
  const activityAttrs =
    result?.activity?.data?.attributes ?? result?.activity?.attributes ?? {};
  const pointsEarned =
    Number(result?.coin_transaction?.points) ||
    Number(activityAttrs?.points_earned) ||
    Number(challenge?.attributes?.reward_points) ||
    0;
  // Only what THIS confirmation paid: since 30/10/2026 the final bonus can come
  // before the last day, and subscription.bonus_earned would announce it again
  // on every following day.
  const bonusEarned = Number(result?.bonus_coin_transaction?.points) || 0;
  const challengeCompleted = Boolean(subAttrs?.completed_at) || result?.challenge_completed || false;
  // This confirmation reached the minimum, and the coins come at the end of the
  // challenge (client, 02/11/2026). The amount comes with the response: the
  // challenge prop is often gone by now (the confirm dialog clears it when it
  // closes, and the notification flow only knows the title).
  const bonusToCome =
    Number(result?.bonus_points_to_come ?? challenge?.attributes?.ontime_bonus_points) || 0;
  const qualifiedNow = Boolean(result?.bonus_qualified_now) && bonusEarned === 0 && bonusToCome > 0;

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose} className="activity-success-modal">
      <div className="activity-success-content">
        <div className="success-icon">
          <IonIcon icon={checkmarkCircle} />
        </div>

        <h2>Attività completata!</h2>

        <p className="success-message">
          Ottimo! Hai guadagnato
        </p>

        <div className="success-rewards">
          <div className="reward-earned">
            <img src={dsCoinImage} alt="DS" />
            <span>+{pointsEarned}</span>
          </div>

          {bonusEarned > 0 && (
            <div className="bonus-earned">
              <span className="trophy">🏆</span>
              <span>+{bonusEarned} Punti bonus</span>
            </div>
          )}
        </div>

        {challengeCompleted ? (
          <p className="challenge-completed-message">
            Hai completato la sfida!
          </p>
        ) : (
          bonusEarned > 0 ? (
            <p className="challenge-completed-message">
              Hai ottenuto il bonus finale!
            </p>
          ) : (
            qualifiedNow && (
              <p className="challenge-completed-message">
                Hai raggiunto il bonus finale! Riceverai +{bonusToCome} monete DS
                alla fine della sfida.
              </p>
            )
          )
        )}

        <IonButton expand="block" className="success-close-btn" onClick={onClose}>
          Ok, grazie
        </IonButton>
      </div>
    </IonModal>
  );
};

export default ActivitySuccessModal;
